import {
  fetchadsCountByGames,
  fetchadsCountByGames12Months,
  fetchDonationsStatsDataReport,
  fetchGamesStatsDataReport,
  fetchPastWeekDonationsReport,
  fetchQuarterlyRevenueReport,
  fetchRegisteredGamesReport,
  fetchRevenueStatsDataReport,
  fetchToppersReportDataReport,
  fetchTotalTraficReport,
  fetchUserStatsDataReport,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";

export const getFormattedAdAnalytics = async (results) => {
  // // // Create all expected month-year strings for the past 12 months
  const allMonths = await getMonths();

  // // // Group by game and fill missing months
  const gamesMap = new Map();
  results.forEach((row) => {
    if (!gamesMap.has(row.game_id)) {
      gamesMap.set(row.game_id, {
        game_id: row.game_id,
        title: row.title,
        data: allMonths.map((month) => ({
          date: month,
          total_ads: 0,
        })),
      });
    }

    // // // Update the specific month with actual data
    const gameData = gamesMap.get(row.game_id);
    const monthIndex = gameData.data.findIndex(
      (item) => item.date === row.date
    );
    if (monthIndex !== -1) {
      gameData.data[monthIndex].total_ads = row.total_ads;
    }
  });

  // // // Convert to array and sort by game_id
  return Array.from(gamesMap.values()).sort((a, b) => a.game_id - b.game_id);
};

export const getMonths = async () => {
  return Array.from({ length: 12 }, (_, i) => {
    const date = new Date();
    date.setMonth(date.getMonth() - i);
    return (
      date.toLocaleString("default", { month: "short" }) +
      "-" +
      date.getFullYear().toString().slice(-2)
    );
  }).reverse();
};

// // // Header Chart Calls
export const getUserStatsDataReport = async (
  setUserStatsDataReport,
  navigation
) => {
  const res = await fetchUserStatsDataReport();
  if (res?.data?.success && res?.data?.data) {
    setUserStatsDataReport(res.data.data);
  } else {
    handleErrors(res, navigation);
  }
};

export const getRevenueStatsDataReport = async (
  setRevenueStatsDataReport,
  navigation
) => {
  const res = await fetchRevenueStatsDataReport();
  if (res?.data?.success && res?.data?.data) {
    setRevenueStatsDataReport(res.data.data);
  } else {
    handleErrors(res, navigation);
  }
};

export const getDonationsStatsDataReport = async (
  setDonationsStatsDataReport,
  navigation
) => {
  const res = await fetchDonationsStatsDataReport();
  if (res?.data?.success && res?.data?.data) {
    setDonationsStatsDataReport(res.data.data);
  } else {
    handleErrors(res, navigation);
  }
};

export const getGamesStatsDataReport = async (
  setGamesStatsDataReport,
  navigation
) => {
  const res = await fetchGamesStatsDataReport();
  if (res?.data?.success && res?.data?.data) {
    setGamesStatsDataReport(res.data.data);
  } else {
    handleErrors(res, navigation);
  }
};

// // // // Calls  For Rest of Charts
export const getRegisteredGamesReport = async (
  setRegisteredGames,
  navigation
) => {
  const res = await fetchRegisteredGamesReport();
  if (res?.data?.success && res?.data?.data) {
    setRegisteredGames(res.data.data);
  } else {
    handleErrors(res, navigation);
  }
};
export const getTotalTraficReport = async (setTotalTrafic, navigation) => {
  const res = await fetchTotalTraficReport();
  if (res?.data?.success && res?.data?.data) {
    setTotalTrafic(res.data.data);
  } else {
    handleErrors(res, navigation);
  }
};

export const getQuarterlyRevenueReport = async (
  setQuarterlyRevenue,
  navigation
) => {
  const res = await fetchQuarterlyRevenueReport();
  if (res?.data?.success && res?.data?.data) {
    setQuarterlyRevenue(res.data.data);
  } else {
    handleErrors(res, navigation);
  }
};

export const getPastWeekDonationsReport = async (
  setPastWeekDonations,
  navigation
) => {
  const res = await fetchPastWeekDonationsReport();
  if (res?.data?.success && res?.data?.data) {
    setPastWeekDonations(res.data.data);
  } else {
    handleErrors(res, navigation);
  }
};

export const getToppersReportDataReport = async (
  setToppersReportData,
  navigation
) => {
  const res = await fetchToppersReportDataReport();
  if (res?.data?.success && res?.data?.data) {
    const temp = res.data.data.filter(
      (f) => f.country != null || f.name != null
    );
    setToppersReportData(temp);
  } else {
    handleErrors(res, navigation);
  }
};

export const getAdVIewCompletionDataReport = async (
  setAdViewCompletionData,
  navigation
) => {
  const res = await fetchadsCountByGames("monthly", "");
  if (res?.data?.success && res?.data?.data) {
    setAdViewCompletionData(res.data.data);
  } else {
    handleErrors(res, navigation);
  }
};

export const getAdViewPerGameDataReport = async (
  setAdViewPerGameData,
  navigation
) => {
  const res = await fetchadsCountByGames12Months();
  if (res?.data?.success && res?.data?.data) {
    const results = await getFormattedAdAnalytics(res.data.data);
    setAdViewPerGameData(results);
  } else {
    handleErrors(res, navigation);
  }
};
